var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable max-depth */
/* eslint-disable complexity */
import { RelayNetworkLayerResponse, RelayNetworkLayerRequest, } from 'react-relay-network-modern';
export default function minificationMiddleware(options) {
    var _this = this;
    return function (next) { return function (req) { return __awaiter(_this, void 0, void 0, function () {
        var operation, fetchOpts, variables, originalFetchOps, e_1, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(req instanceof RelayNetworkLayerRequest)) {
                        return [2 /*return*/, next(req)];
                    }
                    operation = req.operation, fetchOpts = req.fetchOpts, variables = req.variables;
                    if (!(operation.operationKind === 'query' && options.minification)) return [3 /*break*/, 6];
                    originalFetchOps = __assign({}, fetchOpts);
                    req.fetchOpts = _handleMinificationFetchOpts({ fetchOpts: fetchOpts, variables: variables, operation: operation });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 6]);
                    return [4 /*yield*/, next(req)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    e_1 = _a.sent();
                    if (!options.getPersistedQueriesMap) return [3 /*break*/, 5];
                    return [4 /*yield*/, _refetchWithPOSTFromServer(originalFetchOps, {
                            getPersistedQueriesMap: options.getPersistedQueriesMap,
                        })];
                case 4:
                    response = _a.sent();
                    if (response) {
                        return [2 /*return*/, RelayNetworkLayerResponse.createFromFetch(response)];
                    }
                    _a.label = 5;
                case 5: throw e_1;
                case 6: return [2 /*return*/, next(req)];
            }
        });
    }); }; };
}
function _handleMinificationFetchOpts(_a) {
    var fetchOpts = _a.fetchOpts, operation = _a.operation, variables = _a.variables;
    if (!fetchOpts.url) {
        throw new Error('Server url not present!');
    }
    var queryHash = operation.id;
    var url = new URL(fetchOpts.url);
    var searchParams = {
        queryHash: queryHash,
        variables: JSON.stringify(variables),
        operationName: operation.name,
    };
    Object.entries(searchParams).map(function (_a) {
        var _b = __read(_a, 2), name = _b[0], value = _b[1];
        return url.searchParams.append(name, value || '');
    });
    fetchOpts.method = 'GET';
    fetchOpts.url = url.toString();
    // delete fetchOpts.body;
    return fetchOpts;
}
function _refetchWithPOSTFromServer(fetchOpts, _a) {
    var getPersistedQueriesMap = _a.getPersistedQueriesMap;
    return __awaiter(this, void 0, void 0, function () {
        var persistedQueries, body;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(typeof fetchOpts.body === 'string')) {
                        return [2 /*return*/];
                    }
                    if (!fetchOpts.url) {
                        throw new Error('Server url not present!');
                    }
                    return [4 /*yield*/, getPersistedQueriesMap()];
                case 1:
                    persistedQueries = _b.sent();
                    body = JSON.parse(fetchOpts.body);
                    body.query = persistedQueries[body.id];
                    fetchOpts.body = JSON.stringify(body);
                    return [2 /*return*/, fetch(fetchOpts.url, {
                            body: fetchOpts.body,
                            method: fetchOpts.method,
                            headers: fetchOpts.headers,
                        })];
            }
        });
    });
}
//# sourceMappingURL=minification.js.map